export const placements = {
  top: 'top',
  bottom: 'bottom',
  right: 'right',
  left: 'left'
}

export const popperPlacements = {
  ...placements,
  'top-start': 'top-start',
  'top-end': 'top-end',
  'bottom-start': 'bottom-start',
  'bottom-end': 'bottom-end',
  'right-start': 'right-start',
  'right-end': 'right-end',
  'left-start': 'left-start',
  'left-end': 'left-end'
}
